import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-331db77a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ub fw ub-ac ub-pc zhezhao detail-load"
}
const _hoisted_2 = {
  class: "ub ub-ver fw print-div",
  id: "flow-print-table"
}
const _hoisted_3 = { class: "ub ub-ver ub-ac ub-pc fw bgfff header" }
const _hoisted_4 = { class: "ub ub-ac ub-ps sub-title fw" }
const _hoisted_5 = { class: "ub ub-ac ub-ps" }
const _hoisted_6 = { class: "ub ub-ac ub-pc item biz-no" }
const _hoisted_7 = { class: "ub ub-ac ub-pc item-title" }
const _hoisted_8 = { class: "ub ub-ac ub-pc item-content" }
const _hoisted_9 = {
  key: 0,
  class: "ub ub-ac ub-pc item valid-status"
}
const _hoisted_10 = { class: "ub ub-ac ub-pc item-title" }
const _hoisted_11 = { class: "ub ub-ac ub-pc item-content" }
const _hoisted_12 = {
  key: 1,
  class: "ub ub-ac ub-pc item valid-status"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-pc item-title" }, "项目状态：", -1))
const _hoisted_14 = { class: "ub ub-ac ub-pc item-content" }
const _hoisted_15 = { class: "ub ub-ac ub-pc item flow-status" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-pc item-title" }, "审批状态：", -1))
const _hoisted_17 = { class: "ub ub-ac ub-pc item-content" }
const _hoisted_18 = {
  key: 2,
  class: "ub ub-ac ub-pc item flow-status"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ub ub-ac ub-pc item-title" }, "合同状态：", -1))
const _hoisted_20 = { class: "ub ub-ac ub-pc item-content" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "interval-footer" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("打印")

export function render(_ctx, _cache) {
  const _component_a_spin = _resolveComponent("a-spin")
  const _component_a_space = _resolveComponent("a-space")
  const _component_attachment = _resolveComponent("attachment")
  const _component_approval_flow_log_table = _resolveComponent("approval-flow-log-table")
  const _component_print_item = _resolveComponent("print-item")
  const _component_a_button = _resolveComponent("a-button")
  const _component_approval_flow_btn = _resolveComponent("approval-flow-btn")
  const _component_detail_btns = _resolveComponent("detail-btns")
  const _component_Lost_orderBtn = _resolveComponent("Lost-orderBtn")
  const _directive_perm = _resolveDirective("perm")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ub ub-ver fw flow-print", {'in-iframe':_ctx.isIframe}])
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_spin, {
            spinning: _ctx.loading,
            class: "ub spin-loading detail-load-spin"
          }, null, 8, ["spinning"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loopSection, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          (item.show&&item.value==='header')
            ? _renderSlot(_ctx.$slots, "header", {
                key: 0,
                record: _ctx.basicInfo
              }, () => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "subTitle", { record: _ctx.basicInfo }, () => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_a_space, { size: 60 }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.bizNoLabelName) + "：", 1),
                              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.basicInfo?.bizNo), 1)
                            ]),
                            (_ctx.validStatusLabelName?.length>0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.validStatusLabelName) + "：", 1),
                                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.basicInfo?.statusName??_ctx.basicInfo?.validStatusName), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.useNew&&(_ctx.basicInfo?.projectStatusName||_ctx.basicInfo?.statusName))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.basicInfo?.projectStatusName??_ctx.basicInfo?.statusName), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_15, [
                              _hoisted_16,
                              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.basicInfo?.flowStatusName), 1)
                            ]),
                            (_ctx.useNew&&_ctx.contractStatusLabelNameKey?.length>0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _hoisted_19,
                                  _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.contractStatusLabelNameKey), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        })
                      ])
                    ], true)
                  ])
                ])
              ], true)
            : _createCommentVNode("", true),
          (item.show&&item.value==='tabHeader')
            ? _renderSlot(_ctx.$slots, "tabHeader", {
                key: 1,
                record: _ctx.basicInfo
              }, undefined, true)
            : _createCommentVNode("", true),
          (item.show && item.value !=='header'&& item.value !=='tabHeader' && item.value !== 'qrcode'&&((item?.visible&&item?.visible(_ctx.basicInfo))??true))
            ? (_openBlock(), _createBlock(_component_print_item, {
                key: 2,
                class: _normalizeClass([index==1?'first-print-item':'',index==_ctx.loopSection.length-1?'last-print-item':''])
              }, {
                header: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.label), 1)
                ]),
                body: _withCtx(() => [
                  _renderSlot(_ctx.$slots, item.value, { record: _ctx.basicInfo }, () => [
                    (item.value === 'attach' && item.show)
                      ? (_openBlock(), _createBlock(_component_attachment, {
                          key: 0,
                          value: _ctx.attachList,
                          "onUpdate:value": _cache[0] || (_cache[0] = $event => ((_ctx.attachList) = $event)),
                          "biz-id": _ctx.id,
                          "biz-type": _ctx.attachBizType
                        }, null, 8, ["value", "biz-id", "biz-type"]))
                      : _createCommentVNode("", true),
                    (item.value==='flow' && item.show)
                      ? (_openBlock(), _createBlock(_component_approval_flow_log_table, {
                          key: 1,
                          "biz-id": _ctx.id,
                          "biz-type": _ctx.flowBizType,
                          value: _ctx.dataSource,
                          "onUpdate:value": _cache[1] || (_cache[1] = $event => ((_ctx.dataSource) = $event))
                        }, null, 8, ["biz-id", "biz-type", "value"]))
                      : _createCommentVNode("", true)
                  ], true)
                ]),
                _: 2
              }, 1032, ["class"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 128)),
      _hoisted_21,
      _createElementVNode("div", {
        class: "ub ub-ac ub-pc fw detail-footer",
        style: _normalizeStyle({width:_ctx.isIframe?'calc(100% + 32px)':(_ctx.collapsed?'calc(100% - 80px)':'calc(100% - 200px)'),left:_ctx.isIframe?'-16px':(_ctx.collapsed?'80px':'200px')})
      }, [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            (_ctx.showFooter)
              ? _renderSlot(_ctx.$slots, "footer", {
                  key: 0,
                  record: _ctx.basicInfo
                }, () => [
                  _withDirectives((_openBlock(), _createElementBlock("a", {
                    onClick: _cache[2] || (_cache[2] = $event => (_ctx.goto(_ctx.editUrl+'/edit/'+_ctx.id)))
                  }, [
                    (_ctx.showEdit&&!_ctx.useNew)
                      ? (_openBlock(), _createBlock(_component_a_button, { key: 0 }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])), [
                    [_directive_perm, _ctx.editPerm]
                  ]),
                  (!_ctx.useNew)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (_ctx.bizName && _ctx.status !== 'ygb')
                          ? (_openBlock(), _createBlock(_component_approval_flow_btn, {
                              key: 0,
                              "examine-access": _ctx.examinePerm,
                              "biz-id": _ctx.id,
                              eventName: _ctx.listComponentName,
                              createBy: _ctx.createBy,
                              showEditBtn: _ctx.showEditBtn,
                              "onUpdate:showEditBtn": _cache[3] || (_cache[3] = $event => ((_ctx.showEditBtn) = $event)),
                              flowStatus: _ctx.flowStatus,
                              "onUpdate:flowStatus": _cache[4] || (_cache[4] = $event => ((_ctx.flowStatus) = $event)),
                              flowType: _ctx.flowType,
                              "onUpdate:flowType": _cache[5] || (_cache[5] = $event => ((_ctx.flowType) = $event)),
                              "biz-type": _ctx.flowBizType,
                              "biz-name": _ctx.bizName,
                              onRefreshApprovalDetail: _ctx.refresh,
                              disabledVoid: _ctx.disabledVoid,
                              record: _ctx.basicInfo
                            }, null, 8, ["examine-access", "biz-id", "eventName", "createBy", "showEditBtn", "flowStatus", "flowType", "biz-type", "biz-name", "onRefreshApprovalDetail", "disabledVoid", "record"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.useNew&&_ctx.bizName)
                    ? (_openBlock(), _createBlock(_component_detail_btns, {
                        key: 1,
                        "biz-type": _ctx.flowBizType,
                        flowStatusKeyName: _ctx.flowStatusKeyName,
                        "biz-name": _ctx.bizName,
                        record: _ctx.recordNameKey?_ctx.basicInfo[_ctx.recordNameKey]:_ctx.basicInfo,
                        url: _ctx.url,
                        editPerm: _ctx.editPerm,
                        editUrl: _ctx.editUrl,
                        createBy: _ctx.createBy,
                        onRefresh: _ctx.refresh,
                        "examine-access": _ctx.examinePerm,
                        recoverAccess: _ctx.recoverAccess,
                        completelyDeleteAccess: _ctx.completelyDeleteAccess,
                        deleteAccess: _ctx.deleteAccess,
                        bizNameKey: _ctx.bizNameKey,
                        statusKey: _ctx.statusKey,
                        changePerm: _ctx.changePerm,
                        other: _ctx.other
                      }, null, 8, ["biz-type", "flowStatusKeyName", "biz-name", "record", "url", "editPerm", "editUrl", "createBy", "onRefresh", "examine-access", "recoverAccess", "completelyDeleteAccess", "deleteAccess", "bizNameKey", "statusKey", "changePerm", "other"]))
                    : _createCommentVNode("", true),
                  (_ctx.showLostOrderBtn && _ctx.basicInfo?.status !== 'ygb' && _ctx.flowBizType==='project_examine')
                    ? _withDirectives((_openBlock(), _createBlock(_component_Lost_orderBtn, {
                        key: 2,
                        "biz-id": _ctx.id,
                        "biz-type": _ctx.flowBizType,
                        "biz-name": _ctx.bizName,
                        onRefresh: _ctx.refresh,
                        class: "margin-left-14px"
                      }, null, 8, ["biz-id", "biz-type", "biz-name", "onRefresh"])), [
                        [_directive_perm, _ctx.examinePerm]
                      ])
                    : _createCommentVNode("", true),
                  _createVNode(_component_a_button, {
                    onClick: _ctx.goPrint,
                    class: "ml14"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_23
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _renderSlot(_ctx.$slots, "footer-external", {}, undefined, true)
                ], true)
              : _createCommentVNode("", true)
          ]),
          _: 3
        })
      ], 4)
    ])
  ], 2))
}